



























import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class UiChevron extends Vue {
  @Prop({default: false})
  open: boolean;

  @Prop({ default: false })
  disabled: boolean;
  
  @Prop()
  color: string;
  
  @Prop({ default: '13'})
  size: string;
}
